module.exports = __webpack_public_path__ + "img/logo-idt-white.60d7afff.png";